module.exports = __webpack_public_path__ + "static/media/Email_Icon.cfb7b8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer/Email_Icon.png
// module id = 1557
// module chunks = 0